module.exports = __webpack_public_path__ + "media/images/flags/sy-6529aa17e46f775a39317b1ed78a526d.svg";